import React ,{Component } from 'react';
import ShowCertRequestSimple from '../views/showcertrequestsimple';
import { certfileActions,cityActions,provinceActions,countyActions,certformActions,certdocumentActions,certpaymentActions,certrequestActions,certificationTypeActions,certificationTypeGroupActions, certrequestserviceActions } from "../../actions";
import { connect } from 'react-redux';
import { objConstants} from '../../constants/obj.constants'
import { history } from '../../helpers';
import { withRouter } from "react-router-dom";

class ShowCertRequestSimpleContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            provinceList:null,
            cityList:null,
            countyList:null
         }
        this.submit = this.submit.bind(this);
        this.addService = this.addService.bind(this);
        this.submitPayment=this.submitPayment.bind(this); 
        this.updatePayment=this.updatePayment.bind(this); 
        this.submitFiles=this.submitFiles.bind(this);      
        this.deleteService=this.deleteService.bind(this) ;
        this.deleteDocument=this.deleteDocument.bind(this) ;
        this.submitCertForm=this.submitCertForm.bind(this);
        this.issueCertificate=this.issueCertificate.bind(this);
        this.submitUniqueNo=this.submitUniqueNo.bind(this);
        this.submitCam=this.submitCam.bind(this);
        this.submitRevokeCertUniqueNo=this.submitRevokeCertUniqueNo.bind(this);
    }

    issueCertificate(id) {

        //event.preventDefault();
       
        const { dispatch } = this.props;
 
            
        dispatch(certrequestActions.issuecertificate(id,certrequestActions.get(id)));

             
    }
    submit(event) {

        event.preventDefault();
        let data = this.refs.child.getData();
        const { dispatch } = this.props;
        //console.log('data',data);
        if(data.Id)
        {
            //dispatch(patientActions.edit(data,data.Id));

        }else{

            console.log(data);
            dispatch(certrequestActions.add(data));

        }
             
    }

    addService(event) {

        event.preventDefault();
        let data = this.refs.child.getCertReqServiceData();
        const { dispatch } = this.props;
        console.log('*data***',data);
        if(data.Id)
        {
            //dispatch(patientActions.edit(data,data.Id));

        }else{

           // console.log(data);
           const {certreqId}=this.props.match.params;

            dispatch(certrequestserviceActions.add(data,certrequestActions.get(certreqId)));
         //   dispatch(certrequestActions.get(certreqId));

        }
     
    }
    deleteService(id) {
        const { dispatch } = this.props;
        const {certreqId}=this.props.match.params;

        if(id)
        {
            console.log(id);
            dispatch(certrequestserviceActions.delete(id,certrequestActions.get(certreqId)));
          //  dispatch(certrequestActions.get(certreqId));
        }
     
    }
    deleteDocument(id) {
        const { dispatch } = this.props;
        const {certreqId}=this.props.match.params;

        if(id)
        {
            console.log(id);
            dispatch(certdocumentActions.delete(id,certrequestActions.get(certreqId)));
            //dispatch(certrequestActions.get(certreqId));
        }
     
    }
     
    updatePayment(model)
    {
        const { dispatch } = this.props;
        const {certreqId}=this.props.match.params;

        dispatch(certpaymentActions.postbill(model,certpaymentActions.get(model.Id)));
      //  dispatch(certrequestActions.get(certreqId));

    }


    submitPayment(model)
    {
        const { dispatch } = this.props;
        const {certreqId}=this.props.match.params;

        dispatch(certpaymentActions.edit(model,model.Id,certrequestActions.get(certreqId)));
      //  dispatch(certrequestActions.get(certreqId));

    }
    submitFiles(model)
    {
        const { dispatch } = this.props;
        const {certreqId}=this.props.match.params;
       
        dispatch(certdocumentActions.add(model,certrequestActions.get(certreqId)));



       // dispatch(certrequestActions.get(certreqId));

    }

    submitCam(model)
    {
        const { dispatch } = this.props;
        const {CertReqId}=model;
        dispatch(certfileActions.uploadbase64(model,certrequestActions.get(CertReqId)));
    }

    submitUniqueNo(model)
    {
        const { dispatch } = this.props;
        dispatch(certrequestActions.setcertuniqueno(model,certrequestActions.get(model.CertReqId)));
    }

    submitRevokeCertUniqueNo(model)
    {
        const { dispatch } = this.props;
        dispatch(certrequestActions.revokecertuniqueno(model,certrequestActions.get(model.CertificationRequestId)));
    }

    submitCertForm(model)
    {
        const { dispatch } = this.props;
        const {certreqId}=this.props.match.params;
       
        if(model.FormType==0) // legal form
        {
            dispatch(certformActions.edit(model,model.Id,certrequestActions.get(certreqId)));
        }
        if(model.FormType==1) // moral form
        {
            dispatch(certformActions.edit(model,model.Id,certrequestActions.get(certreqId)));
        }
        if(model.FormType==2) // moral inspect form
        {
            dispatch(certformActions.edit(model,model.Id,certrequestActions.get(certreqId)));
        }
     }

    componentDidMount(){
       

       const {certreqId}=this.props.match.params;

       console.log('Props',this.props);

       const { dispatch } = this.props;   

        if (certreqId) {

            let id = certreqId;
             
            dispatch(certrequestActions.get(id));   
            dispatch(cityActions.gets());
            dispatch(provinceActions.gets());
            dispatch(countyActions.gets());  
        
        } 

        dispatch(certificationTypeGroupActions.gets()); 

        dispatch(certificationTypeActions.gets()); 
       
    }

    componentWillReceiveProps(newProps)
    {
        const {items}=newProps;
        if(items && items.provinceList)
        {
           this.setState({
            provinceList:items.provinceList
           })
        }
        if(items && items.countyList)
        {
            this.setState({
                countyList:items.countyList
               })
        }
        if(items && items.cityList)
        {
            this.setState({
                cityList:items.cityList
               })
        }
        console.log('yyyy',newProps);
    }
    

    render() { 

        const { type,obj,items } = this.props;
        const {cityList,countyList,provinceList}=this.state;
        console.log('Items',items);
        if(type==objConstants.ADD_SUCCESS)
        {
           // console.log('Added successfully');
           // history.push('/certrequestlist')
        }
        if(type==objConstants.UPDATE_SUCCESS)
        {
           // console.log('Updated successfully');
           // history.push('/patients')
        }
     
        return ( 
            <ShowCertRequestSimple submitRevokeUniqueNoHandler={this.submitRevokeCertUniqueNo}  submitCamHandler={this.submitCam}  submitUniqueNoHandler={this.submitUniqueNo} provincelist={provinceList && provinceList} countylist={countyList && countyList} citylist={cityList && cityList} submitCertFormHandler={this.submitCertForm} deleteServiceHandler={this.deleteService} deleteDocumentHandler={this.deleteDocument} certissueHandler={this.issueCertificate} submitFileHandler={this.submitFiles} submitPaymentHandler={this.submitPayment} updatePaymentHandler={this.updatePayment} btnAddServiceHandler={this.addService}  model={(obj!=null && obj.CertReq!=null)?obj.CertReq:null}  certTypeGroupList={(items!=null && items.cerTypeGroups!=null)?items.cerTypeGroups:null} certTypeList={(items!=null && items.certTypes!=null)?items.certTypes:null} {...this.props}  ref="child" />
         );
    }
}

function mapStateToProps(state,ownProps) {
    const { loading,type,item,items } = state.objs;
    
   //console.log('STATE',state)
    //const { type } = state;
    return {
        loading,
        type,
        obj:item,
        items
       
    };
} 

export default withRouter(connect(mapStateToProps)(ShowCertRequestSimpleContainer));